import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  private lang: string | null;

  constructor(private translate: TranslateService) {
    this.lang = null;
  }

  clear() {

  }

  private availableLanguages = ["el", "en", "hr"];

  hasStoredLanguage() {
    return localStorage.getItem("lang") != null;
  }

  getLanguage() {
    if (this.lang == null) {
      this.lang = localStorage.getItem("lang");
    }

    const lang = this.lang ?? "el";

    return this.availableLanguages.indexOf(lang) == -1 ? "en" : lang;
  }

  setLanguage(lang: string) {
    this.lang = lang;
    this.translate.use(lang);
    return localStorage.setItem("lang", lang);
  }

}
